class BlockScrollText {
	constructor() {
		this.scrollTexts = document.querySelectorAll(".scroll-text");
		if (this.scrollTexts) {
			this.buildScrollText();
			resizeCallbacks.push(this);
		}
	}

	buildScrollText() {
		this.scrollTexts.forEach(text => {
			gsap.to(text, {
				x: () => {
					let value = text.scrollWidth - window.innerWidth;
					value = value - (value * 2);
					return value;
				},
				duration: 1,
				scrollTrigger: {
					trigger: text,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 0.8,
					invalidateOnRefresh: true
				}

			});
		});
	}

	resize() {
		ScrollTrigger.refresh();
	}
}